import { ISchedule } from '@Safemate/Settings/Sensor/types';
import React from 'react';
import { useIntl } from 'react-intl';
import Toggle from '@Elements/Switch/Toggle';
import { DayName } from './styles';

interface DayProps{
  day: ISchedule;
  checked: boolean;
  onChange: (value: boolean) => void;
}

const Day = ({day, checked, onChange}: DayProps) => {

  const { formatMessage } = useIntl();

  return (
    <React.Fragment>
      <DayName active={checked}>
        {formatMessage({id: day.day.toLowerCase(), defaultMessage: day.day.toLowerCase()})}
      </DayName>
      <Toggle
        checked={checked}
        onChange={onChange}
      />
    </React.Fragment>
  );
}

export default Day;
